/** @format */
export const ProductRecommendationsPageType = {
  CART: 'Cart',
  ORDER_CONFIRMATION: 'OrderConfirmation',
  ORDER_DETAILS: 'OrderDetails',
  PDP: 'PDP',
  FAVORITES: 'List Contents',
};
